module.exports = __webpack_public_path__ + "img/avatar5.14590610.png";